// Every query key of architecture §21.2 as a function (WP0). The list is binding: screens use these and SSE handlers
// (lib/sse.ts) patch exactly these keys. Filters are plain objects so TanStack Query hashes them structurally.
import type { CockpitData } from '@hq/shared';

export type Filter = Record<string, string | number | boolean | null | undefined>;
export type CockpitRange = CockpitData['range'];

export const qk = {
  authState: () => ['authState'] as const,
  bootstrap: () => ['bootstrap'] as const,

  thread: (threadId: string) => ['thread', threadId] as const,
  messages: (threadId: string) => ['messages', threadId] as const,
  threads: (filter: Filter = {}) => ['threads', filter] as const,

  cockpit: (range: CockpitRange) => ['cockpit', range] as const,

  agents: () => ['agents'] as const,
  agent: (agentId: string) => ['agent', agentId] as const,
  agentTools: (agentId: string) => ['agentTools', agentId] as const,
  templates: () => ['templates'] as const,

  /** `['jobs','takeover']` (claude.ai takeover card) and `['jobs', {agentId}]`. */
  jobsTakeover: () => ['jobs', 'takeover'] as const,
  jobs: (filter: Filter = {}) => ['jobs', filter] as const,
  memories: (filter: Filter = {}) => ['memories', filter] as const,
  runs: (filter: Filter = {}) => ['runs', filter] as const,
  run: (runId: string) => ['run', runId] as const,
  usage: (filter: Filter = {}) => ['usage', filter] as const,

  tasks: (filter: Filter = {}) => ['tasks', filter] as const,
  task: (taskId: string) => ['task', taskId] as const,

  /** status: 'offen' | 'erledigt' (§21.2 filter) */
  approvals: (status?: string) => (status === undefined ? (['approvals'] as const) : (['approvals', status] as const)),
  approval: (approvalId: string) => ['approval', approvalId] as const,

  calendar: (from: string, to: string) => ['calendar', from, to] as const,

  reports: (filter: Filter = {}) => ['reports', filter] as const,
  report: (reportId: string) => ['report', reportId] as const,

  settings: () => ['settings'] as const,
  models: () => ['models'] as const,
  budget: () => ['budget'] as const,
  integrations: () => ['integrations'] as const,
  integration: (key: string) => ['integrations', key] as const,
  mcpServers: () => ['mcpServers'] as const,
  sessions: () => ['sessions'] as const,
  passkeys: () => ['passkeys'] as const,
  tokenKey: () => ['tokenKey'] as const,

  voiceStatus: () => ['voice', 'status'] as const,
  voiceVoices: () => ['voice', 'voices'] as const,
  pushDevices: () => ['push', 'devices'] as const,
  call: (callId: string) => ['call', callId] as const,
} as const;

export type QueryKeys = typeof qk;
